import { render, staticRenderFns } from "./OrganisationEmpty.vue?vue&type=template&id=6f9bbcbd"
import script from "./OrganisationEmpty.vue?vue&type=script&lang=js"
export * from "./OrganisationEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports